import React from 'react';
import BeanCard from './BeanCard';


const BeansGrid = ({ beans, language, loading, error }) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
        {[...Array(6)]?.map((_, index) => (
          <div key={index} className="bg-card border border-border rounded-lg p-4 animate-pulse">
            <div className="w-full h-48 bg-muted rounded-lg mb-4"></div>
            <div className="h-6 bg-muted rounded mb-2"></div>
            <div className="h-4 bg-muted rounded w-3/4"></div>
          </div>
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-12">
        <p className="text-error">{error}</p>
      </div>
    );
  }

  if (!beans || beans?.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-muted-foreground">
          {language === 'en' ? 'No coffee beans found matching your criteria.' : '未找到符合您条件的咖啡豆。'}
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
      {beans?.map((bean) => (
        <BeanCard key={bean?.id} bean={bean} language={language} />
      ))}
    </div>
  );
};

export default BeansGrid;